export enum LoginEnum {
    NotFoundUser = 1,
    InactiveUser = 2,
    DeletedUser = 3,
    MissingTermsAndCond = 4,
    Success = 5,
    ServerError = 6,
    TermsAcceptedSuccessfully = 7,
    ErrorAcceptingTerms = 8
}